export const ICON_MAPPING: Record<string, string> = {
  'lucide lucide-landmark': 'ReceiptText',
  'lucide-landmark': 'ReceiptText',
  'lucide lucide-pie-chart': 'ReceiptText',
  'lucide-pie-chart': 'ReceiptText',
  'lucide lucide-receipt': 'ReceiptText',
  'lucide-receipt': 'ReceiptText',
  'lucide lucide-database': 'ReceiptText',
  'lucide-database': 'ReceiptText',
  'lucide lucide-folder': 'ReceiptText',
  'lucide-folder': 'ReceiptText',
  'lucide lucide-user': 'ReceiptText',
  'lucide-user': 'ReceiptText',
  'lucide lucide-calculator': 'ReceiptText',
  'lucide-calculator': 'ReceiptText',
  'lucide lucide-layout-dashboard': 'ReceiptText',
  'lucide-layout-dashboard': 'ReceiptText',
  'lucide lucide-home': 'ReceiptText',
  'lucide-home': 'ReceiptText',
  'lucide lucide-settings': 'ReceiptText',
  'lucide-settings': 'ReceiptText',
  'lucide lucide-building': 'ReceiptText',
  'lucide-building': 'ReceiptText',
  'lucide lucide-credit-card': 'ReceiptText',
  'lucide-credit-card': 'ReceiptText',
  'lucide lucide-bar-chart': 'ReceiptText',
  'lucide-bar-chart': 'ReceiptText',
};
